module.exports = __webpack_public_path__ + "static/media/8977.f8f2ece6.jpg";